import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Box } from '@material-ui/core';
import Header from './components/header';
import ProgramsTable from './components/programsTable';
import TableExport from './components/tableExport';
import { ProgramsAPI } from '../../../API/API-programs';
import DeleteProgram from './components/deleteProgram';
import '../../../css/programsList.css';

export default class ProgramsHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      programsData: [],
      search: '',
      ages: [],
      seasons: [],
      selectedItems: [],
      openDeleteProgram: false,
      selectedProgramID: '',
      selectedProgramName: '',
      values: {
        allAges: false,
        preSchool: false,
        children: false,
        children8_12: false,
        youth: false,
        adult: false,
        senior: false,
        information: false,
        allSeasons: false,
        winter: false,
        spring: false,
        summer: false,
        fall: false,
      },
    };
  }

  componentDidMount() {
    const { userData } = this.props;
    if (userData.userData.userType === 'Program Staff') {
      ProgramsAPI.GET.getProgramByInstructorID(userData.userData._id)
        .then((success) => {
          console.log(success);
          this.setState({ programsData: success.data });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      // <--- get all programs on DB --->
      ProgramsAPI.GET.getProgramsHistory()
        .then((success) => {
          this.setState({ programsData: success.data });
          console.log(success.data);
          console.log(success);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  handleFilter = (name, value, filterName, selectedAge) => {
    const { values, selectedItems } = this.state;
    if (value === true) {
      values[name] = value;
      this.setState({
        values,
        [filterName]: this.state[filterName].concat([selectedAge]),
        selectedItems: selectedItems.concat([
          <Box className="programsList-selectedItems" key={selectedAge} name={name} id={filterName}>
            {selectedAge}
            <i
              label="filterItems"
              className="far fa-times-circle ml-2 "
              onClick={() => this.handleFilter(name, false, filterName, selectedAge)}
              onKeyPress={() => this.handleFilter(name, false, filterName, selectedAge)}
              role="button"
              tabIndex={0}
            />
          </Box>,
        ]),
      });
    } else {
      // remove filter immutably
      const updateArray = [...this.state[filterName]].filter(item => item !== selectedAge);

      // remove selectedItems immutably
      const updateSelectedItems = [...this.state.selectedItems].filter(item => item.key !== selectedAge);

      values[name] = value;
      this.setState({ values, [filterName]: updateArray, selectedItems: updateSelectedItems });
    }
  };

  resetFilters = () => {
    const { values } = this.state;
    Object.keys(values).forEach((key) => {
      values[key] = false;
    });
    this.setState({
      values,
      seasons: [],
      ages: [],
      selectedItems: [],
    });
  };

  handleExport = (value) => {
    if (value === 'Print') {
      const printContent = document.getElementById('tableExport').innerHTML;
      document.body.innerHTML = printContent;
      window.print();
      window.location = '/adminPortal/programs';
    } else {
      const table = document.getElementById('tableExport').innerHTML;
      const convertTable = table
        .toString()
        .replace(/<div>/g, '')
        .toString()
        .replace(/<\/div>/g, '')
        .toString()
        .replace(/<table class="table">/g, '')
        .toString()
        .replace(/<\/table>/g, '')
        .toString()
        .replace(/<td>/g, '')
        .toString()
        .replace(/<\/td>/g, ',')
        .toString()
        .replace(/<tr>/g, '')
        .toString()
        .replace(/<\/tr>/g, '\r\n')
        .toString()
        .replace(/<th scope="col">/g, '')
        .toString()
        .replace(/<\/th>/g, ',')
        .toString()
        .replace(/<thead>/g, '')
        .toString()
        .replace(/<\/thead>/g, '')
        .toString()
        .replace(/<tbody>/g, '')
        .toString()
        .replace(/<\/tbody>/g, '')
        .toString()
        .replace(/<\/t>/g, '')
        .toString()
        .replace(/<\/n>/g, '');
      const myLink = document.createElement('a');
      myLink.download = 'programsList.csv';
      myLink.href = `data:application/csv,${escape(convertTable)}`;
      myLink.click();
    }
  };

  handleProgramSelection = (selectionObj) => {
    const { history } = this.props;
    switch (selectionObj.selectionType) {
      case 'Program Registration':
        history.push(`/adminPortal/programs/programRegistration/${selectionObj.programID}`);
        break;
      case 'Program Details':
        history.push(`/adminPortal/programs/programDetails/${selectionObj.programID}`);
        break;
      case 'Edit':
        history.push(`/adminPortal/programs/editProgram/${selectionObj.programID}`);
        break;
      case 'Attendees':
        history.push(`/adminPortal/programs/registrationList/${selectionObj.programID}`);
        break;
      case 'Event Attendance':
        history.push({
          pathname: `/adminPortal/programs/createAttendance/${selectionObj.programID}`,
          state: { fromHistory: true }
        });
        break;
      case 'Delete':
        this.setState({
          selectedProgramID: selectionObj.programID,
          selectedProgramName: selectionObj.programName,
          openDeleteProgram: true,
        });
        break;
      default:
        break;
    }
  };

  render() {
    const {
      ages, seasons, values, selectedItems, programsData, search, openDeleteProgram, selectedProgramID, selectedProgramName,
    } = this.state;
    const { history, userData } = this.props;
    return (
      <Grid item xs className="font-family-default">
        <Header
          handleExport={this.handleExport}
          getSearch={(value) => this.setState({ search: value })}
          handleAddNewProgram={() => history.push('/adminPortal/programs/addNewProgram/programInformation')}
          handleFilter={this.handleFilter}
          search={(value) => this.setState({ search: value })}
          ages={ages}
          seasons={seasons}
          values={values}
          selectedItems={selectedItems}
          resetFilters={this.resetFilters}
          userType={userData.userData.userType}
        />

        <ProgramsTable data={programsData} sortSeason={seasons} sortSearch={search} sortAges={ages} handleProgramSelection={this.handleProgramSelection} />
        <Grid className="hidden" id="tableExport">
          <TableExport data={programsData} sortSeason={seasons} sortSearch={search} sortAges={ages} />
        </Grid>

        <DeleteProgram open={openDeleteProgram} close={() => this.setState({ openDeleteProgram: false })} selectedProgramID={selectedProgramID} selectedProgramName={selectedProgramName} />
      </Grid>
    );
  }
}

ProgramsHistory.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  userData: PropTypes.shape({
    _id: PropTypes.string,
    userType: PropTypes.string,
  }).isRequired,
};
